import { NormalIconProps } from 'assets/icons';
import React from 'react';

export const ClearSearchedTextIcon: React.FC<NormalIconProps> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" className={props.className} onClick={props.onClick}>
		<circle cx="10" cy="10" r="8.333" stroke="#AFB3B1" strokeWidth="1.25" />
		<path stroke="#AFB3B1" strokeLinecap="round" strokeWidth="1.25" d="m12.083 7.917-4.167 4.166m0-4.166 4.167 4.166" />
	</svg>
);
